import { Injectable } from '@angular/core';
import { AuthModel, defaultAuthModelValues } from '../components/authorize/auth-model';
import { ApplicationLanguages } from '../components/language/language';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    constructor() { }
    timeZoneName:string='Pacific Standard Time'
    getAuthToken(): any {
        if (localStorage.getItem('token') == null) {
            return null;
        }
        return localStorage.getItem('token');
    }

    logout(): void {
        localStorage.clear();
    }

    checkTokenExpiry(): Boolean {
        const storeDate = localStorage.getItem('tokenExpiry');
        const tokenExpiry = storeDate ? new Date(storeDate) : new Date()
        const currentDate = new Date();
        const currentUtcTime = Date.UTC(
            currentDate.getUTCFullYear(),
            currentDate.getUTCMonth(),
            currentDate.getUTCDate(),
            currentDate.getUTCHours(),
            currentDate.getUTCMinutes(),
            currentDate.getUTCSeconds(),
            currentDate.getUTCMilliseconds()
        );
        if (tokenExpiry > new Date(currentUtcTime)) {
            return true;
        }
        else {
            this.logout();
            return false;
        }
    }



    setUserLoginData(authmodel: AuthModel) {
        localStorage.setItem('username', authmodel.username);
        localStorage.setItem('token', authmodel.token);
        localStorage.setItem('tokenExpiry', authmodel.expiryUtc)
        localStorage.setItem('isParticipant', JSON.stringify(authmodel.isParticipant));
        localStorage.setItem('agentname', authmodel.agentName)
        localStorage.setItem('passwordchangerequireddays', authmodel.passwordChangeRequiredDays.toString())
        localStorage.setItem('userDbId', authmodel.userDbId.toString())
        localStorage.setItem('language',authmodel.participantLastActiveLanguage.toString())
        localStorage.setItem('showbblogo', JSON.stringify(authmodel.showBBLogo))
    }

    getUserLoginData(): AuthModel {
        let userData = defaultAuthModelValues();
        userData.agentName = localStorage.getItem('agentname')!,
        userData.username = localStorage.getItem('username')!,
        userData.token = localStorage.getItem('token')!,
        userData.expiryUtc = localStorage.getItem('tokenExpiry')!
        userData.passwordChangeRequiredDays = parseInt(localStorage.getItem('passwordchangerequireddays')!)
        userData.userDbId = parseInt(localStorage.getItem('userDbId')!)
        userData.isParticipant = JSON.parse(localStorage.getItem('isParticipant')!)
        userData.participantLastActiveLanguage = parseInt(localStorage.getItem('language')!) as ApplicationLanguages
        userData.showBBLogo = JSON.parse(localStorage.getItem('showbblogo')!)
        return userData;
    }

  
}